import { useMerchant } from "@/lib/useMerchant";
import DashboardHeader from "@/components/DashboardHeader";
import DashboardFooter from "@/components/DashboardFooter";
import ProfileInfo from "@/pages/ProfileInfo";

export default function ProfilePage() {
  const { me, loading } = useMerchant();

  if (loading || !me) {
    return (
      <div className="min-h-screen bg-cream">
        <DashboardHeader me={me} />
        <div className="grid h-64 place-items-center text-sm text-ink/50">Loading…</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-cream">
      <DashboardHeader me={me} />
      <ProfileInfo />
      <DashboardFooter />
    </div>
  );
}
